// Roles translations for React Admin resource
export const rolesResource = {
  name: '角色 |||| 角色',
  fields: {
    id: 'ID',
    name: '角色名稱',
    description: '描述',
    permissions: '權限',
    users: '用戶',
    createdAt: '創建時間',
    updatedAt: '更新時間',
    userCount: '分配的用戶',
  },
};

// Custom roles translations for components
export const roles = {
  subtitle: '管理用戶角色及其權限',
  permissions: '權限 |||| 權限',
  selected: '已選擇',
  system_role_info: '這是系統角色，無法刪除。您仍可以修改其權限。',
  permissions_info: '選擇此角色應具有的權限。擁有此角色的用戶將能夠執行所選操作。',
  permissions_warning: '更改權限將影響所有擁有此角色的用戶。請在保存前仔細檢查。',
  validation: {
    name_format: '角色名稱只能包含字母、數字、空格和連字符',
  },
  helpers: {
    name: '為此角色選擇一個描述性名稱（例如："站點管理員"、"只讀"）',
    description: '描述此角色的用途以及誰應該擁有它',
  },
  sections: {
    basic_info: '基本信息',
    permissions: '權限',
    role_info: '角色信息',
  },
  actions: {
    save: '保存角色',
  },
  create: {
    title: '創建新角色',
    subtitle: '定義具有特定權限的新角色',
  },
  edit: {
    title: '編輯角色',
    subtitle: '修改角色詳情和權限',
  },
  delete: {
    title: '刪除角色',
    content: '您確定要刪除此角色嗎？此操作無法撤銷。',
  },
  list: {
    title: '角色與權限',
    filters: {
      search: '搜尋',
    },
    empty: {
      title: '找不到角色',
      subtitle: '創建您的第一個角色以管理用戶權限。',
    },
    users: '用戶 |||| 用戶',
  },
  notifications: {
    created: '角色創建成功',
    updated: '角色更新成功',
    deleted: '角色刪除成功',
    error: {
      create: '創建角色失敗',
      update: '更新角色失敗',
      delete: '刪除角色失敗',
      system_role: '無法刪除系統角色',
    },
  },
  groups: {
    users: '後台用戶',
    roles: '角色與權限',
    sites: '充電站點',
    'load-groups': '負載組',
    chargers: '充電器',
    'charger-types': '充電器類型',
    transactions: '交易',
    reservations: '預約',
    'reservation-policies': '預約政策',
    'user-groups': '用戶群組',
    app_users: '應用用戶',
    wallet: '錢包',
    settings: '系統設置',
    audit: '稽核日誌',
    reports: '報告與分析',
    messages: '應用內訊息',
    banners: '促銷橫幅',
    promotions: '促銷活動與優惠券',
  },
  permissionGroups: {
    users: {
      label: '後台用戶',
      permissions: {
        'users:read:all': {
          label: '檢視所有用戶',
          description: '可以檢視所有後台用戶帳戶',
        },
        'users:create:all': {
          label: '創建用戶',
          description: '可以創建新的後台用戶帳戶',
        },
        'users:update:all': {
          label: '編輯用戶',
          description: '可以修改現有的後台用戶帳戶',
        },
        'users:write:all': {
          label: '創建和編輯用戶（舊版）',
          description: '舊版總括權限,建議改用獨立的「創建」與「編輯」權限。',
        },
        'users:admin:all': {
          label: '刪除用戶',
          description: '可以刪除用戶帳戶和管理用戶設置',
        },
      },
    },
    roles: {
      label: '角色與權限',
      permissions: {
        'roles:read:all': {
          label: '檢視角色',
          description: '可以檢視所有角色及其權限',
        },
        'roles:write:all': {
          label: '管理角色',
          description: '可以創建和修改角色',
        },
        'roles:admin:all': {
          label: '刪除角色',
          description: '可以刪除角色和管理角色分配',
        },
      },
    },
    sites: {
      label: '充電站點',
      permissions: {
        'sites:read:all': {
          label: '檢視所有站點',
          description: '可以檢視所有充電站點信息',
        },
        'sites:write:all': {
          label: '管理站點',
          description: '可以創建和編輯充電站點',
        },
        'sites:admin:all': {
          label: '刪除站點',
          description: '可以刪除站點和管理站點設置',
        },
      },
    },
    'load-groups': {
      label: '負載組',
      permissions: {
        'load-groups:read:all': {
          label: '檢視負載組',
          description: '可以檢視電源管理組',
        },
        'load-groups:write:all': {
          label: '管理負載組',
          description: '可以創建和編輯負載組',
        },
        'load-groups:admin:all': {
          label: '刪除負載組',
          description: '可以刪除負載組',
        },
      },
    },
    chargers: {
      label: '充電器',
      permissions: {
        'chargers:read:all': {
          label: '檢視所有充電器',
          description: '可以檢視所有充電站',
        },
        'chargers:write:all': {
          label: '管理充電器',
          description: '可以添加和修改充電器',
        },
        'chargers:admin:all': {
          label: '刪除充電器',
          description: '可以從系統中移除充電器',
        },
        'chargers:reboot': {
          label: '重啟充電樁',
          description: '透過 OCPP 遠端重啟充電樁（軟重啟或硬重啟）',
        },
      },
    },
    'charger-types': {
      label: '充電器類型',
      permissions: {
        'charger-types:read:all': {
          label: '檢視充電器類型',
          description: '可以檢視充電器類型配置',
        },
        'charger-types:write:all': {
          label: '管理充電器類型',
          description: '可以創建和編輯充電器類型',
        },
        'charger-types:admin:all': {
          label: '刪除充電器類型',
          description: '可以刪除充電器類型定義',
        },
      },
    },
    transactions: {
      label: '交易',
      permissions: {
        'transactions:read:all': {
          label: '檢視交易',
          description: '可以檢視所有充電交易',
        },
        'transactions:write:all': {
          label: '修改交易',
          description: '可以編輯交易記錄',
        },
        'transactions:admin:all': {
          label: '管理交易',
          description: '可以刪除和退款交易',
        },
      },
    },
    reservations: {
      label: '預約',
      permissions: {
        'reservations:read:all': {
          label: '檢視預約',
          description: '可以檢視所有預約',
        },
        'reservations:write:all': {
          label: '管理預約',
          description: '可以取消、徵收失約費、重新指派以及強制釋放錢包凍結',
        },
        'reservations:admin:all': {
          label: '刪除預約',
          description: '可以取消任何預約',
        },
      },
    },
    'reservation-policies': {
      label: '預約政策',
      permissions: {
        'reservation-policies:read:all': {
          label: '檢視預約政策',
          description: '可以檢視所有站點、充電器或負載群組的預約政策',
        },
        'reservation-policies:write:all': {
          label: '管理預約政策',
          description: '可以建立、編輯及刪除預約政策',
        },
      },
    },
    'user-groups': {
      label: '用戶群組',
      permissions: {
        'user-groups:read:all': {
          label: '檢視用戶群組',
          description: '可以檢視所有用於預約資格判定的用戶群組',
        },
        'user-groups:write:all': {
          label: '管理用戶群組',
          description: '可以建立、編輯、刪除用戶群組及管理成員',
        },
      },
    },
    'app-users': {
      label: '應用程式用戶',
      permissions: {
        'app-users:read:all': {
          label: '檢視應用程式用戶',
          description: '可以檢視行動應用程式用戶',
        },
        'app-users:write:all': {
          label: '管理應用程式用戶',
          description: '可以編輯應用程式用戶帳號',
        },
        'app-users:admin:all': {
          label: '刪除應用程式用戶',
          description: '可以刪除應用程式用戶帳號',
        },
      },
    },
    'app-account-deletion': {
      label: '應用程式帳號刪除',
      permissions: {
        'account_deletion_requests:process:all': {
          label: '處理帳號刪除申請',
          description: '檢視應用程式帳號刪除申請並執行處理（會將用戶資料匿名化）',
        },
      },
    },
    'app-versions': {
      label: '應用程式版本',
      permissions: {
        'app-versions:read:all': {
          label: '檢視應用程式版本',
          description: '檢視已設定的 iOS 和 Android 版本資料',
        },
        'app-versions:write:all': {
          label: '管理應用程式版本',
          description: '編輯 iOS 和 Android 版本資料,包括強制更新門檻及商店連結',
        },
      },
    },
    wallet: {
      label: '錢包',
      permissions: {
        'wallet:read:all': {
          label: '檢視錢包',
          description: '可以檢視所有用戶錢包',
        },
        'wallet:write:all': {
          label: '管理錢包',
          description: '可以調整錢包餘額',
        },
        'wallet:admin:all': {
          label: '刪除錢包',
          description: '可以刪除錢包記錄',
        },
      },
    },
    settings: {
      label: '系統設置',
      permissions: {
        'settings:read:all': {
          label: '檢視設置',
          description: '可以檢視系統配置',
        },
        'settings:write:all': {
          label: '修改設置',
          description: '可以更改系統設置',
        },
        'settings:admin:all': {
          label: '管理設置',
          description: '可以管理關鍵設置',
        },
      },
    },
    audit: {
      label: '稽核日誌',
      permissions: {
        'audit:read:all': {
          label: '檢視稽核日誌',
          description: '可以檢視系統活動日誌和用戶操作',
        },
        'audit:write:all': {
          label: '管理稽核日誌',
          description: '可以導出和管理稽核日誌保留',
        },
        'audit:admin:all': {
          label: '管理稽核日誌',
          description: '可以刪除稽核日誌和管理稽核設置',
        },
      },
    },
    reports: {
      label: '報告與分析',
      permissions: {
        'reports:revenue:read': {
          label: '營收分析',
          description: '可以檢視營收分析報告',
        },
        'reports:transactions:read': {
          label: '交易量',
          description: '可以檢視交易量報告',
        },
        'reports:sessions:read': {
          label: '時段分析',
          description: '可以檢視充電時段分析報告',
        },
        'reports:charger-utilization:read': {
          label: '充電樁使用率',
          description: '可以檢視充電樁使用率報告',
        },
        'reports:energy-consumption:read': {
          label: '能源消耗',
          description: '可以檢視能源消耗報告',
        },
        'reports:peak-usage:read': {
          label: '峰值使用量',
          description: '可以檢視峰值使用量分析報告',
        },
        'reports:user-activity:read': {
          label: '用戶活動',
          description: '可以檢視用戶活動報告',
        },
        'reports:vendor-performance:read': {
          label: '供應商效能（僅限管理員）',
          description: '可以檢視跨供應商效能比較報告',
        },
        'reports:site-comparison:read': {
          label: '站點比較',
          description: '可以檢視站點比較報告',
        },
        'reports:total-sessions:read': {
          label: '總時段數',
          description: '可在報表及匯出中查看總時段數（包括未輸出電量的時段）；否則只顯示已充電時段',
        },
        'reports:kiosk:read': {
          label: 'Kiosk',
          description: 'Can view and export the kiosk report: monthly pay-out, daily match, refunds health and overview',
        },
      },
    },
    notifications: {
      label: '通知',
      permissions: {
        'notifications:read:all': {
          label: '檢視通知',
          description: '可以檢視通知群組、分配和日誌',
        },
        'notifications:write:all': {
          label: '管理通知',
          description: '可以創建和編輯通知群組，添加/移除成員',
        },
        'notifications:manage:all': {
          label: '完全通知控制',
          description: '可以刪除群組、管理偏好設置和重試失敗的通知',
        },
      },
    },
    'email-routing': {
      label: '電郵服務商路由',
      permissions: {
        'email_routing:read:all': {
          label: '檢視電郵路由',
          description: '可以檢視每個範本的電郵服務商路由及預設服務商',
        },
        'email_routing:write:all': {
          label: '管理電郵路由',
          description: '可以變更每個範本的電郵服務商、預設服務商，並啟用或停用範本',
        },
      },
    },
    messages: {
      label: '應用內訊息',
      permissions: {
        'messages:read:all': {
          label: '檢視訊息',
          description: '可以檢視所有應用內訊息及其統計資料',
        },
        'messages:write:all': {
          label: '建立和編輯訊息',
          description: '可以建立新訊息和編輯草稿或已排程的訊息',
        },
        'messages:send:all': {
          label: '發送訊息',
          description: '可以向用戶發送訊息和推播通知',
        },
        'messages:admin:all': {
          label: '完全訊息控制',
          description: '可以刪除訊息並管理所有訊息設定',
        },
      },
    },
    banners: {
      label: '促銷橫幅',
      permissions: {
        'banners:read:all': {
          label: '查看橫幅',
          description: '可以查看所有促銷橫幅及其詳細資訊',
        },
        'banners:write:all': {
          label: '建立和編輯橫幅',
          description: '可以建立新橫幅和編輯現有的促銷內容',
        },
        'banners:analytics:all': {
          label: '查看橫幅分析',
          description: '可以存取橫幅效能指標和分析數據',
        },
        'banners:admin:all': {
          label: '完全橫幅控制',
          description: '可以刪除橫幅、管理目標規則和控制所有橫幅設定',
        },
      },
    },
    promotions: {
      label: '促銷活動與優惠券',
      permissions: {
        'promotions:read:all': {
          label: '查看促銷活動',
          description: '可以查看所有促銷活動、優惠券和兌換記錄',
        },
        'promotions:write:all': {
          label: '管理促銷活動',
          description: '可以建立、編輯促銷活動和生成優惠券代碼',
        },
        'promotions:export:all': {
          label: '匯出促銷資料',
          description: '可以匯出優惠券代碼和兌換報表為 CSV 格式',
        },
        'promotions:admin:all': {
          label: '完全促銷控制',
          description: '可以刪除促銷活動、查看分析數據和管理所有促銷設定',
        },
      },
    },
    'ocpp-servers': {
      label: 'OCPP 伺服器',
      permissions: {
        'ocpp-servers:read:all': {
          label: '檢視 OCPP 伺服器',
          description: '可以檢視 OCPP 伺服器配置和狀態',
        },
        'ocpp-servers:write:all': {
          label: '管理 OCPP 伺服器',
          description: '可以創建和編輯 OCPP 伺服器配置',
        },
        'ocpp-servers:admin:all': {
          label: '刪除 OCPP 伺服器',
          description: '可以刪除 OCPP 伺服器並管理伺服器憑證',
        },
      },
    },
    'ocpp-templates': {
      label: 'OCPP 模板',
      permissions: {
        'ocpp-templates:read:all': {
          label: '檢視 OCPP 模板',
          description: '可以檢視所有 OCPP 配置模板',
        },
        'ocpp-templates:write:all': {
          label: '管理 OCPP 模板',
          description: '可以創建和編輯 OCPP 配置模板',
        },
        'ocpp-templates:admin:all': {
          label: '刪除 OCPP 模板',
          description: '可以刪除 OCPP 模板並設定預設配置',
        },
      },
    },
    'supabase-connections': {
      label: 'Supabase 連線',
      permissions: {
        'supabase-connections:read:all': {
          label: '檢視 Supabase 連線',
          description: '可以檢視 Supabase 連線配置和狀態',
        },
        'supabase-connections:write:all': {
          label: '管理 Supabase 連線',
          description: '可以創建、編輯和測試 Supabase 連線',
        },
        'supabase-connections:admin:all': {
          label: '刪除 Supabase 連線',
          description: '可以刪除連線並管理加密憑證',
        },
      },
    },
    'lms-logs': {
      label: 'LMS 日誌',
      permissions: {
        'lms-logs:read:all': {
          label: '檢視 LMS 日誌',
          description: '可以檢視負載管理系統決策日誌和歷史記錄',
        },
        'lms-logs:write:all': {
          label: '導出 LMS 日誌',
          description: '可以導出和下載 LMS 日誌數據',
        },
        'lms-logs:admin:all': {
          label: '管理 LMS 日誌',
          description: '可以刪除 LMS 日誌並配置保留策略',
        },
      },
    },
    'ocpp-logs': {
      label: 'OCPP 日誌',
      permissions: {
        'ocpp-logs:read:all': {
          label: '檢視 OCPP 日誌',
          description: '可依充電樁與時間範圍查詢及檢視原始 OCPP 協議訊息',
        },
      },
    },
    'lms-templates': {
      label: 'LMS 模板',
      permissions: {
        'lms-templates:read:all': {
          label: '檢視 LMS 模板',
          description: '可以檢視所有負載管理系統模板和配置',
        },
        'lms-templates:write:all': {
          label: '管理 LMS 模板',
          description: '可以創建和編輯負載管理系統模板',
        },
        'lms-templates:admin:all': {
          label: '刪除 LMS 模板',
          description: '可以刪除 LMS 模板並管理模板設定',
        },
      },
    },
    'kiosk-transactions': {
      label: '付款亭交易',
      permissions: {
        'kiosk-transactions:read:all': {
          label: '讀取付款亭交易',
          description: '檢視及匯出付款亭付款及退款，並以八達通號碼搜尋',
        },
        'kiosk-transactions:write:all': {
          label: '管理付款亭交易',
          description: '把已過期的八達通退款標記為已人手退款',
        },
      },
    },
    'kiosk-settlements': {
      label: 'Octopus settlements',
      permissions: {
        'kiosk-settlements:read:all': {
          label: 'Read Octopus settlements',
          description: 'View and export each Octopus reader settlement beside our record, and see overdue settlements',
        },
      },
    },
    'kiosk-alerts': {
      label: 'Kiosk alerts',
      permissions: {
        'kiosk-alerts:read:all': {
          label: 'Read kiosk alerts',
          description: 'See kiosk alerts and their counts. Site owners see only the day-to-day alerts of their own sites',
        },
        'kiosk-alerts:write:all': {
          label: 'Write kiosk alerts',
          description: 'Mark a kiosk alert handled with a note',
        },
      },
    },
    'kiosk-releases': {
      label: 'Kiosk releases',
      permissions: {
        'kiosk-releases:read:all': {
          label: 'Read kiosk releases',
          description: 'View kiosk software releases, rollouts and install progress',
        },
        'kiosk-releases:write:all': {
          label: 'Write kiosk releases',
          description: 'Upload, roll out, pause and revoke kiosk software releases',
        },
      },
    },
    'kiosk-release-keys': {
      label: 'Kiosk release keys',
      permissions: {
        'kiosk-release-keys:write:all': {
          label: 'Write kiosk release keys',
          description: 'Create, rotate and replace the kiosk release key',
        },
      },
    },
    'kiosk-devices': {
      label: '付款亭',
      permissions: {
        'kiosk-devices:read:all': {
          label: '讀取付款亭',
          description: '檢視付款亭、其健康狀態及設定',
        },
        'kiosk-devices:write:all': {
          label: '管理付款亭',
          description: '登記、啟用、設定及停用付款亭',
        },
      },
    },
    vendors: {
      label: '供應商',
      permissions: {
        'vendors:read:all': {
          label: '檢視供應商',
          description: '可以檢視所有供應商帳戶及其詳細資料',
        },
        'vendors:write:all': {
          label: '管理供應商',
          description: '可以創建和編輯供應商帳戶及站點分配',
        },
        'vendors:admin:all': {
          label: '刪除供應商',
          description: '可以刪除供應商帳戶並管理供應商設定',
        },
      },
    },
    'rfid-users': {
      label: 'RFID 用戶',
      permissions: {
        'rfid-users:read:all': {
          label: '檢視 RFID 用戶',
          description: '可以檢視所有純 RFID 用戶帳戶',
        },
        'rfid-users:write:all': {
          label: '管理 RFID 用戶',
          description: '可以創建和編輯 RFID 用戶帳戶',
        },
        'rfid-users:admin:all': {
          label: '刪除 RFID 用戶',
          description: '可以刪除 RFID 用戶帳戶並管理用戶卡片',
        },
      },
    },
    'rfid-cards': {
      label: 'RFID 卡片',
      permissions: {
        'rfid-cards:read:all': {
          label: '檢視 RFID 卡片',
          description: '可以檢視所有 RFID 卡片及其分配',
        },
        'rfid-cards:write:all': {
          label: '管理 RFID 卡片',
          description: '可以創建、編輯和分配 RFID 卡片到站點',
        },
        'rfid-cards:admin:all': {
          label: '刪除 RFID 卡片',
          description: '可以刪除卡片、批量匯入/匯出，並管理卡片設定',
        },
      },
    },
    'app-transactions': {
      label: '應用程式交易',
      permissions: {
        'app-transactions:read:all': {
          label: '檢視應用程式交易',
          description: '可以檢視所有應用程式付款交易和詳細資料',
        },
        'app-transactions:write:all': {
          label: '管理應用程式交易',
          description: '可以創建和編輯應用程式付款交易記錄',
        },
        'app-transactions:export:all': {
          label: '匯出應用程式交易',
          description: '可以匯出應用程式交易資料並生成報告',
        },
        'app-transactions:admin:all': {
          label: '管理員應用程式交易',
          description: '完全控制應用程式交易，包括退款和調整',
        },
      },
    },
    'app-topups': {
      label: '應用程式增值',
      permissions: {
        'app-topups:read:all': {
          label: '檢視增值記錄',
          description: '可檢視錢包增值交易及用戶錢包餘額',
        },
        'app-topups:export:all': {
          label: '匯出增值記錄',
          description: '可將增值交易資料匯出為 CSV',
        },
        'app-topups:admin:all': {
          label: '管理員增值記錄',
          description: '完全控制增值記錄，包括退款',
        },
      },
    },
    'rfid-transactions': {
      label: 'RFID 交易',
      permissions: {
        'rfid-transactions:read:all': {
          label: '檢視 RFID 交易',
          description: '可以檢視所有 RFID 付款交易和詳細資料',
        },
        'rfid-transactions:write:all': {
          label: '管理 RFID 交易',
          description: '可以創建和編輯 RFID 付款交易記錄',
        },
        'rfid-transactions:export:all': {
          label: '匯出 RFID 交易',
          description: '可以匯出 RFID 交易資料並生成報告',
        },
        'rfid-transactions:admin:all': {
          label: '管理員 RFID 交易',
          description: '完全控制 RFID 交易，包括退款和調整',
        },
      },
    },
    'active-sessions': {
      label: '活動充電時段',
      permissions: {
        'active-sessions:read:all': {
          label: '檢視活動時段',
          description: '可以檢視和監控所有活動中的充電時段',
        },
        'charging_sessions:manual_start': {
          label: '手動啟動時段',
          description: '手動為用戶啟動充電時段或獨立啟動用於測試/維護',
        },
        'charging_sessions:manual_stop': {
          label: '手動停止時段',
          description: '手動停止任何活動的充電時段並記錄原因',
        },
        'charging_sessions:force_complete': {
          label: '強制完成時段',
          description: '當充電樁離線或無法連線時（網路中斷、硬體故障），手動強制完成卡住的時段',
        },
      },
    },
    'charging-sessions': {
      label: '充電歷史記錄',
      permissions: {
        'charging-sessions:read:all': {
          label: '檢視充電歷史',
          description: '可以檢視所有已歸檔的充電時段及其詳細資料',
        },
        'charging-sessions:export:all': {
          label: '匯出充電歷史',
          description: '可將充電歷史記錄（每筆交易的使用報告）匯出為 Excel',
        },
        'charging-sessions:view-analytics:all': {
          label: '檢視「分析」分頁',
          description: '可在充電時段詳細頁中檢視「分析」分頁（電表數值圖表）',
        },
        'charging-sessions:view-payment:all': {
          label: '檢視「付款」分頁',
          description: '可在充電時段詳細頁中檢視「付款」分頁（費用明細與付款資料）',
        },
        'charging-sessions:view-ocpp:all': {
          label: '檢視 OCPP 記錄',
          description: '可檢視「OCPP 記錄」分頁與「檢視 OCPP 記錄」按鈕，並可呼叫對應 API',
        },
        'charging-sessions:view-technical:all': {
          label: '檢視「技術資料」分頁',
          description: '可在充電時段詳細頁中檢視「技術資料」分頁（溫度、錯誤次數、歸檔資料）',
        },
      },
    },
    'charger-firmware': {
      label: '充電樁韌體',
      permissions: {
        'charger-firmware:read:all': {
          label: '檢視韌體檔案',
          description: '可以檢視所有韌體檔案及其其他資料',
        },
        'charger-firmware:write:all': {
          label: '上傳韌體檔案',
          description: '可以上傳新的韌體檔案並編輯韌體其他資料',
        },
        'charger-firmware:admin:all': {
          label: '刪除韌體檔案',
          description: '可以從系統中刪除韌體檔案',
        },
      },
    },
    'firmware-updates': {
      label: '韌體更新',
      permissions: {
        'firmware-updates:read:all': {
          label: '檢視更新任務',
          description: '可以檢視所有韌體更新任務及其狀態',
        },
        'firmware-updates:write:all': {
          label: '建立更新任務',
          description: '可以建立韌體更新任務並排程充電樁更新',
        },
        'firmware-updates:admin:all': {
          label: '管理更新任務',
          description: '可以取消韌體更新任務並查詢狀態',
        },
      },
    },
    'fee-templates': {
      label: '費用模板',
      permissions: {
        'fee-templates:read:all': {
          label: '檢視費用模板',
          description: '可以檢視所有費用模板及其配置',
        },
        'fee-templates:write:all': {
          label: '建立和編輯費用模板',
          description: '可以建立新的費用模板和編輯現有模板',
        },
        'fee-templates:admin:all': {
          label: '刪除費用模板',
          description: '可以刪除費用模板並管理模板設定',
        },
      },
    },
    'fee-schedules': {
      label: '費用時段',
      permissions: {
        'fee-schedules:read:all': {
          label: '檢視費用時段',
          description: '可以檢視所有費用時段及其時段定價規則',
        },
        'fee-schedules:write:all': {
          label: '建立和編輯費用時段',
          description: '可以建立新的費用時段和編輯現有時段',
        },
        'fee-schedules:admin:all': {
          label: '刪除費用時段',
          description: '可以刪除費用時段並管理時段設定',
        },
      },
    },
    'payment-settings': {
      label: '支付設定',
      permissions: {
        'payment-settings:read:all': {
          label: '檢視支付設定',
          description: '可以檢視支付閘道和支付方式配置',
        },
        'payment-settings:write:all': {
          label: '管理支付設定',
          description: '可以編輯支付閘道設定、啟用/停用支付方式，以及調整支付方式順序',
        },
      },
    },
    'vehicle-catalog': {
      label: '車輛型錄',
      permissions: {
        'vehicle-catalog:read:all': {
          label: '檢視車輛型錄',
          description: '檢視車輛品牌和型號',
        },
        'vehicle-catalog:write:all': {
          label: '管理車輛型錄',
          description: '新增、編輯和刪除車輛品牌和型號',
        },
        'vehicle-catalog:import:all': {
          label: '匯入車輛型錄',
          description: '從 PDF 批次匯入車輛型號',
        },
      },
    },
    'ai-troubleshooting': {
      label: 'AI 故障排除',
      permissions: {
        'ai_troubleshooting:use:all': {
          label: '使用 AI 故障排除',
          description: '執行 AI 故障排除調查、檢視權限範圍內的調查記錄與詳情，以及複製或下載開發人員除錯交接資料包',
        },
        'ai_troubleshooting:manage:all': {
          label: '管理 AI 故障排除',
          description: '將調查提升為診斷手冊、管理診斷手冊與模型設定、檢視重複故障分析，以及執行模型 A/B 比較（第二階段）',
        },
      },
    },
  },
};